// JavaScript Document
//components/signs/option/Form.js
import React from 'react';
//import PropTypes from 'prop-types';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
//import Card from '@material-ui/core/Card';
//import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
//import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from '../forms/ImagePicker';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';


export default function OptionForm(props) {
  	//const classes = useStyles();
	//inherited variables
  	const {onChange, control, options, value, id, name, choices, label} = props;
	const [checked, setChecked] = React.useState(false);
	//const [num, setNum] = React.useState(value);
	React.useEffect(() => {
		if(control === 'toggle'){
			if(value === options.valueOn){
				setChecked(true);
			} else {
				setChecked(false);
			}
		}
		/*
		if(control === 'number'){
			if(!isNaN(value))
				setNum(value);
		}
		*/
	}, [control, options, value]);
	const handleSwitch = (e) => {
		let tog = e.target.checked;
		let res = {
			target: {
				name : name,
				value : tog ? options.valueOn : options.valueOff
			}
		};
		setChecked(tog);
		if(onChange)
			onChange(res);
	}
	const handleNumber = (e) => {
		let val = e.target.value;
		if(isNaN(val) || parseInt(val) < options.min){
			val = options.min;
		} else if(parseInt(val) > options.max){
			val = options.max;
		}
		let res = {
			target: {
				name : name,
				value : val
			}
		};
		//setNum(val);
		if(onChange)
			onChange(res);
	}
	if(control === 'picklist')
		return (
			<TextField
				id={id}
				name={name}
				label={label}
				value={value}
				type="text"
				onChange={onChange}
				fullWidth
				select 
			>
				{choices.map((item, i) => (
				<MenuItem value={item.value} key={i}>{item.name}</MenuItem>
				))}
			</TextField>
		
		);
	if(control === 'toggle')
		return (
			<Box display="flex" justifyContent="space-between" alignItems="center">
			<Typography>{label}</Typography>
			<FormGroup aria-label={label} row>
				<FormControlLabel
					control={<Switch color="primary" checked={checked} onChange = {handleSwitch} />}
					label={checked ? options.labelOn : options.labelOff}
				/>
			</FormGroup>
			</Box>
		);
	if(control === 'number')
		return (
			<TextField 
				id={id} 
				name={name}
				label={label}
				value={!isNaN(value) ? value.toString() : "0"}
				onChange={handleNumber}
				type="number" 
				inputProps={{min: options.min, max:options.max, step:options.step}}
				fullWidth
			/>
		);
  	return (
		<TextField
			id={id}
			name={name}
			label={label}
			value={value}
			type="text"
			onChange={onChange}
			fullWidth
		/>
  	);
}
